/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface ObterAnexoRequest {
  id: string;
  onSuccess?: (anexo: AnexoPublicado) => void;
}

export interface AnexoPublicado {
  id: string;
  fileName: string;
  mimeType: string;
  size: number;
  label?: string | null;
  createdAt: string;
  /** "ZonaUrbana" ou "AreaEspecial". */
  origem: string;
  idDono: string;
  sigla: string;
  nome: string;
  /** URL pré-assinada de download (força o save). */
  url: string;
  /** URL pré-assinada de visualização no navegador. */
  urlView: string;
}

interface State {
  isRequesting: boolean;
  /** Qual anexo está sendo resolvido, para o spinner ficar na linha certa. */
  idEmAndamento: string | null;
  successPayload: AnexoPublicado | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  idEmAndamento: null,
  successPayload: null,
  errors: []
};

const obterAnexoSlice = createSlice({
  name: "consultaprevia@obterAnexo",
  initialState,
  reducers: {
    obterAnexo: (state, action: PayloadAction<ObterAnexoRequest>): void => {
      state.isRequesting = true;
      state.idEmAndamento = action.payload.id;
      state.errors = [];
    },
    obterAnexoSuccess: (state, action: PayloadAction<AnexoPublicado>): void => {
      state.isRequesting = false;
      state.idEmAndamento = null;
      state.successPayload = action.payload;
    },
    obterAnexoFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.idEmAndamento = null;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: { type: string; payload: ObterAnexoRequest }) {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/consulta-previa/anexos/${params.payload.id}`
    );

    const { data }: { data: AnexoPublicado } = response;

    if (params.payload.onSuccess) params.payload.onSuccess(data);

    yield put(obterAnexoSuccess(data));
  } catch (error) {
    yield put(obterAnexoFailed(formatError(error)));
  }
}

export const { obterAnexo, obterAnexoSuccess, obterAnexoFailed } =
  obterAnexoSlice.actions;
export const { reducer } = obterAnexoSlice;
export const saga = takeLatest(obterAnexo.type, sagaFunction);
